<button class="btn btn-block btn-secondary mb-myaccount-back-to-myaccount-btn text-initial"
        data-cy="mb-myaccount-back-to-myaccount-btn"
        type="button"
        (click)="executeClick()">
  {{ textTranslationPath | cxTranslate }}
</button>
